var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent",attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true}}),(
      _vm.$router.currentRoute.path != '/auth' &&
      _vm.$router.currentRoute.name != 'view'
    )?[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu},on:{"menu-click":_vm.menuClick}})]:_vm._e(),_c('router-view'),(_vm.$router.currentRoute.name != 'view')?_c('footer-bar'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }